import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    selectedClusters: {},
    modifiedClusters: [],
    selectAllTaxoIds: [],
    expandedTaxoIds: {}
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
